import React from "react";

export default function ChartColIcon({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  onClick,
  className,
  style = {},
  ...rest
}) {
  const mergedStyle = Object.assign(
    { width: size, height: size, cursor: onClick ? "pointer" : undefined },
    style
  );
  
  const svgProps = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    fill: "none",
    stroke: color,
    strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    onClick,
    className,
    style: mergedStyle,
    ...rest
  };
  
  return React.createElement(
    "svg",
    svgProps,
    React.createElement("path", {
      d: "M3 3v16a2 2 0 0 0 2 2h16"
    }),
    React.createElement("path", {
      d: "M18 17V9"
    }),
    React.createElement("path", {
      d: "M13 17V5"
    }),
    React.createElement("path", {
      d: "M8 17v-3"
    })
  );
}